import loader from './lib/Loader';

import(/* webpackPrefetch: true */ './icons');
loader('slider', '.slider');
loader('quote-slider', '.quote-slider');
loader('navbar', '.header');
loader('menu', '.menu');
loader('newsletter-form', '.newsletter-form');
loader('images-popup', '.image-grid__more-images');
loader('popup', '.overlay');
loader('member-validation', '#tribe-tickets__registration-form');
loader('copy-text', '.copy-text');
loader('gallery-archive', '.gallery-events__filter');
loader('quantity', '.uitjes-quantity');
